import { GOOGLE_MAPS_API_KEY } from "../config/googleMaps.js";

let bootstrapped = false;

/**
 * Google's own official inline bootstrap loader (the currently recommended
 * replacement for the old synchronous `<script src=".../maps/api/js?key=...">`
 * tag — see https://developers.google.com/maps/documentation/javascript/load-maps-js-api).
 * Only fetches the tiny loader script once (idempotent — the IIFE guards
 * itself against a second run); actual libraries are fetched on demand via
 * `importLibrary()`, batched into a single request.
 *
 * This is never called until a caller actually needs a map (see
 * EventsMap.jsx, only mounted once the user switches to the "Karte" view)
 * — that on-demand loading is what keeps this within the Maps JavaScript
 * API's free monthly quota (see konzepte/GOOGLE_MAPS_SETUP.md).
 */
function bootstrap() {
  if (bootstrapped) return;
  bootstrapped = true;
  ((g) => {
    let h;
    let a;
    let k;
    const p = "The Google Maps JavaScript API";
    const c = "google";
    const l = "importLibrary";
    const q = "__ib__";
    const m = document;
    let b = window;
    b = b[c] || (b[c] = {});
    const d = b.maps || (b.maps = {});
    const r = new Set();
    const e = new URLSearchParams();
    const u = () =>
      h ||
      (h = new Promise((resolve, reject) => {
        a = m.createElement("script");
        e.set("libraries", [...r].join(","));
        for (k in g) e.set(k.replace(/[A-Z]/g, (t) => `_${t[0].toLowerCase()}`), g[k]);
        e.set("callback", `${c}.maps.${q}`);
        a.src = `https://maps.${c}apis.com/maps/api/js?${e}`;
        d[q] = resolve;
        a.onerror = () => {
          h = undefined;
          reject(new Error(`${p} could not load.`));
        };
        a.nonce = m.querySelector("script[nonce]")?.nonce || "";
        m.head.append(a);
      }));
    d[l] ? console.warn(`${p} only loads once. Ignoring:`, g) : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
  })({ key: GOOGLE_MAPS_API_KEY, v: "weekly" });
}

export async function loadGoogleMapsLibrary(name) {
  bootstrap();
  return window.google.maps.importLibrary(name);
}
